import type { IRequestOptions, IValidatedResponse } from '../../httpClient';
import { getRequest } from '../../httpClient';
import type { IGetUserBillingHistoryV1Response } from './get-user-billing-history-v1-response';
import { getUserBillingHistoryV1ResponseSchema } from './get-user-billing-history-v1-response';

export async function getUserBillingHistoryV1Api(
  userId: string,
  options?: IRequestOptions,
): Promise<IValidatedResponse<IGetUserBillingHistoryV1Response>> {
  return getRequest<IGetUserBillingHistoryV1Response>({
    path: `/sys/billing/v1/users/${userId}/history`,
    schema: getUserBillingHistoryV1ResponseSchema,
    options,
  });
}
